import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import VueSweetalert2 from "vue-sweetalert2";
// import VueQrcodeReader from "vue-qrcode-reader";
import moment from "moment";
import cognitoAuth from "./cognito";
import router from "./router";
import store from "./store";
import Vuetify from "vuetify";
import VuetifyGoogleAutocomplete from "vuetify-google-autocomplete";
import Croppa from "vue-croppa";
import "vue-croppa/dist/vue-croppa.css";
import "sweetalert2/dist/sweetalert2.min.css";
import "../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../node_modules/ag-grid-community/dist/styles/ag-theme-alpine.css";
import VueStripeCheckout from "vue-stripe-checkout";
import VueApexCharts from "vue-apexcharts";
import { TiptapVuetifyPlugin } from "tiptap-vuetify";
import "tiptap-vuetify/dist/main.css";
localStorage.setItem("currentUser", JSON.stringify({}));
localStorage.setItem("currentUserData", JSON.stringify({}));

Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: "AIzaSyCEOXvOemWbayaHWZDNAAY1VN-U7EfFohU"
});
Vue.use(Vuetify);

Vue.directive("clickable", {
  inserted: function(el) {
    el.style.cursor = "pointer";
  }
});

Vue.prototype.$moment = moment;

Vue.config.productionTip = false;

Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

Vue.use(VueSweetalert2);

// Vue.use(VueQrcodeReader);
Vue.use(Croppa);

Vue.use(moment);

// Vue.use(ApexCharts);

Vue.use(TiptapVuetifyPlugin, {
  // the next line is important! You need to provide the Vuetify Object to this place.
  vuetify, // same as "vuetify: vuetify"
  // optional, default to 'md' (default vuetify icons before v2.0.0)
  iconsGroup: "mdi"
});

new Vue({
  vuetify,
  router,
  cognitoAuth,
  store,
  head: {
    meta: [
      {
        name: "viewport",
        content:
          "width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover"
      }
    ]
  },
  beforeCreate() {
    this.$store.dispatch("loadItems");
    this.$store.dispatch("initAuth");
    setInterval(() => {
      this.$store.dispatch("initAuth");
      console.log("Initializing Auth");
    }, 300000);

    // this.$store.dispatch("setFullLoaderState", true);
    // this.$store.dispatch("loadSiteData").then(() => {
    //     this.$store.dispatch("initAuth");
    // });
  },
  render: h => h(App)
}).$mount("#app");
